export enum PaymentTypes {
  None = 0,
  CHEQUE,
  CASH,
  OTHER,
  OB,
}
